{
  "en": {
    "logged_out": {
      "success": {
        "login": "Resume session",
        "title": "Your session has ended!"
      }
    }
  }
}
